import * as React from 'react'

import { Box, Button, Hint } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { getImagesByLocale } from '../assets/getImagesByLocale'

interface Props {
  setOpenHint: (open: boolean) => void
  setOpenSettingsVersionModal: (open: boolean) => void
}

const NewFormulaHint: React.FC<Props> = ({ setOpenHint, setOpenSettingsVersionModal }) => {
  const [step1 = '', step2 = '', step3 = ''] = getImagesByLocale(i18n.locale)

  return (
    <Hint.NewModal onClose={() => setOpenHint(false)} onFinish={() => setOpenHint(true)}>
      <Hint.NewModal.ImageStep
        src={step1}
        title={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_1.title'
        )}
        description={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_1.description'
        )}
      />
      <Hint.NewModal.ImageStep
        src={step2}
        title={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_2.title'
        )}
        description={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_2.description'
        )}
      />
      <Hint.NewModal.ImageStep
        src={step3}
        title={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_3.title'
        )}
        description={i18n.t(
          'time_tracking.settings.work_time_categories.special_work_hours.hint.step_3.description'
        )}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          {i18n.t(
            'time_tracking.settings.work_time_categories.special_work_hours.hint.step_3.footer'
          )}
          <Button
            onClick={() => {
              setOpenSettingsVersionModal(true)
              setOpenHint(false)
            }}
          >
            {i18n.t(
              'time_tracking.settings.work_time_categories.special_work_hours.callout.button_action'
            )}
          </Button>
        </Box>
      </Hint.NewModal.ImageStep>
    </Hint.NewModal>
  )
}

export default NewFormulaHint
